import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HistoryBoxComponent} from './history-box.component';
const routes: Routes = [
  {
    path: '',
    component: HistoryBoxComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HistoryBoxRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/history-box/history-box-routing.module.ts